// Lib
import * as React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// Hooks
import useUser from '../../../hooks/useUser';

import { useStyles } from './ProgressSpinnerStyles';

function ProgressSpinner({ value, className }) {
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({ isKiteUser });

  return (
    <div className={cx(classes.root, className)}>
      <CircularProgress
        size={90}
        thickness={2}
        className={classes.progress}
        variant="determinate"
        value={value}
      />
      <CircularProgress
        size={90}
        thickness={2}
        className={cx(classes.progress, classes.absoluteProgress)}
        variant="determinate"
        value={100}
      />
      <Box className={classes.overlay}>
        <Typography variant="h3" component="div" color="#929A92">{`${Math.round(
          value,
        )}%`}</Typography>
      </Box>
    </div>
  );
}

export default ProgressSpinner;
